import React from 'react';

interface PageHeroProps {
  title: string;
  subtitle: string;
  className?: string;
}

const PageHero: React.FC<PageHeroProps> = ({ title, subtitle, className = '' }) => {
  return (
    <section className={`page-hero ${className}`} style={{background: 'linear-gradient(120deg, #003366 70%, rgba(0,102,204,0.8) 100%)', padding: '140px 0 80px 0'}}>
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h1 className="text-white mb-3" style={{fontSize: '3rem', fontWeight: 900}}>{title}</h1>
            <p className="text-white page-hero-subtitle" style={{fontSize: '1.6rem', fontWeight: 800, opacity: 0.94}}>{subtitle}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageHero;

